import * as notes from '../stores/wrapper-mod';
export const lookup = {
  0: "C",
  1: "Db",
  2: "D",
  3: "Eb",
  4: "E",
  5: "F",
  6: "Gb",
  7: "G",
  8: "Ab",
  9: "A",
  10: "Bb",
  11: "B",
};

export const intervalLookup = {
  0: "Unison",
  1: "m2",
  2: "M2",
  3: "m3",
  4: "M3",
  5: "P4",
  6: "Tritone",
  7: "P5",
  8: "m6",
  9: "M6",
  10: "m7",
  11: "M7",
  12: "Octave",
};
export function  getFileForNoteNumber(num) {
    const noteLetterName = lookup[parseInt(num,10) % 12];
    const octNum = parseInt(num / 12,10);
    return notes[`${noteLetterName}${octNum}`];
 }

export function getMajorChordFromNoteNumber(num) {
  const chord = [num, num+4, num+7];
  return chord.map( num => {
    return getFileForNoteNumber(num);
  });
}
export function getMinorChordFromNoteNumber(num) {
  const chord = [num, num+3, num+7];
  return chord.map( num => {
    return getFileForNoteNumber(num);
  });
}
export function getDiminshedChordFromNoteNumber(num) {
  const chord = [num, num+3, num+6];
  return chord.map( num => {
    return getFileForNoteNumber(num);
  });
}
export function getAugmentedChordFromNoteNumber(num) {
  const chord = [num, num+4, num+8];
  return chord.map( num => {
    return getFileForNoteNumber(num);
  });
}



// WEBPACK FOOTER //
// ./src/utils/chord-builder.js